import React, { useEffect, useState } from 'react';

import axios from '../../api/axios';

import {
    Container,
    Header,
    FeedList
} from './styles';
import FeedCard from '../../components/FeedCard';

const FEEDS_URL = '/feeds';

interface IFeedData {
    id : string;
    content : string;
    createData : string;
    userName : string;
}

const HomePage: React.FC = () => {

    const [page, setPage] = useState(0);
    const [feedsData, setFeedsData] = useState<IFeedData[]>([]);

    useEffect(() => {
        axios.get(FEEDS_URL, {
            params: {
                size: 3,
                sort: 'id,desc',
                page: page
            }
        }).then(response => {
            const r = response.data.content.map((item: any) : IFeedData => {
                return {
                    id: item.id,
                    createData: String(item.dataCriacao),
                    content: item.content,
                    userName: item.userName
                }
            })
            setFeedsData(r);
            
        })
        .catch(e => {
            console.log(e);
        })
    }, []);
    
    return (
        <Container>
            <Header>
                <h1>Bem vindo a Área do Cliente Nia!</h1>
            </Header>

            <FeedList>
                <h2>Feed</h2>
                    {
                        feedsData.map((item : IFeedData ) => (
                            <FeedCard 
                                key={item.id}
                                content={item.content}
                                userName={item.userName}
                                createData={item.createData}
                            />
                        ))
                    }

            </FeedList>

        </Container>
    )
}

export default HomePage;